import type { KibLabelVariants } from '@chewy/kib-label-react'

import i18n from '~/locales/i18n'

import { PrescriptionDeclineReasonType } from './PrescriptionWorkflow'

export enum RxDisplayStatus {
  VET_APPROVED = 'VET_APPROVED',
  PENDING_VET_APPROVAL = 'PENDING_VET_APPROVAL',
  DECLINED_PET_NEEDS_TO_BE_SEEN = 'DECLINED_PET_NEEDS_TO_BE_SEEN',
  DECLINED_WRONG_PRODUCT = 'DECLINED_WRONG_PRODUCT',
  DECLINED_NOT_A_CLINIC_PATIENT = 'DECLINED_NOT_A_CLINIC_PATIENT',
  DECLINED_WRONG_PET = 'DECLINED_WRONG_PET',
  DECLINED_WRONG_COUNT = 'DECLINED_WRONG_COUNT',
  DECLINED_OTHER = 'DECLINED_OTHER',
  CANCELED = 'CANCELED',
  EXPIRED = 'EXPIRED',
}

export const RxDisplayStatusToVariant: Record<
  RxDisplayStatus,
  KibLabelVariants
> = {
  [RxDisplayStatus.VET_APPROVED]: 'success',
  [RxDisplayStatus.PENDING_VET_APPROVAL]: 'caution',
  [RxDisplayStatus.DECLINED_PET_NEEDS_TO_BE_SEEN]: 'danger',
  [RxDisplayStatus.DECLINED_WRONG_PRODUCT]: 'danger',
  [RxDisplayStatus.DECLINED_NOT_A_CLINIC_PATIENT]: 'danger',
  [RxDisplayStatus.DECLINED_WRONG_PET]: 'danger',
  [RxDisplayStatus.DECLINED_WRONG_COUNT]: 'danger',
  [RxDisplayStatus.DECLINED_OTHER]: 'danger',
  [RxDisplayStatus.CANCELED]: 'danger',
  [RxDisplayStatus.EXPIRED]: 'default',
}

export const RxDisplayStatusLabel: Record<RxDisplayStatus, string> = {
  [RxDisplayStatus.VET_APPROVED]: i18n.t('Common:RX_STATUS.VET_APPROVED'),
  [RxDisplayStatus.PENDING_VET_APPROVAL]: i18n.t('Common:PENDING_VET_APPROVAL'),
  [RxDisplayStatus.DECLINED_PET_NEEDS_TO_BE_SEEN]: i18n.t(
    'Common:RX_STATUS.DECLINED_PET_NEEDS_TO_BE_SEEN',
  ),
  [RxDisplayStatus.DECLINED_WRONG_PRODUCT]: i18n.t(
    'Common:RX_STATUS.DECLINED_WRONG_PRODUCT',
  ),
  [RxDisplayStatus.DECLINED_NOT_A_CLINIC_PATIENT]: i18n.t(
    'Common:RX_STATUS.DECLINED_NOT_A_CLINIC_PATIENT',
  ),
  [RxDisplayStatus.DECLINED_WRONG_PET]: i18n.t(
    'Common:RX_STATUS.DECLINED_WRONG_PET',
  ),
  [RxDisplayStatus.DECLINED_WRONG_COUNT]: i18n.t(
    'Common:RX_STATUS.DECLINED_WRONG_COUNT',
  ),
  [RxDisplayStatus.DECLINED_OTHER]: i18n.t('Common:RX_STATUS.DECLINED_OTHER'),
  [RxDisplayStatus.CANCELED]: i18n.t('Common:RX_STATUS.CANCELED'),
  [RxDisplayStatus.EXPIRED]: i18n.t('Common:RX_STATUS.EXPIRED'),
}

export const DeclineReasonToDisplayStatus: Partial<
  Record<PrescriptionDeclineReasonType, RxDisplayStatus>
> = {
  [PrescriptionDeclineReasonType.PET_NEEDS_TO_BE_SEEN]:
    RxDisplayStatus.DECLINED_PET_NEEDS_TO_BE_SEEN,
  [PrescriptionDeclineReasonType.WRONG_PRODUCT]:
    RxDisplayStatus.DECLINED_WRONG_PRODUCT,
  [PrescriptionDeclineReasonType.NOT_A_CLINIC_PATIENT]:
    RxDisplayStatus.DECLINED_NOT_A_CLINIC_PATIENT,
  [PrescriptionDeclineReasonType.WRONG_PET]: RxDisplayStatus.DECLINED_WRONG_PET,
  [PrescriptionDeclineReasonType.WRONG_COUNT]:
    RxDisplayStatus.DECLINED_WRONG_COUNT,
  [PrescriptionDeclineReasonType.OTHER]: RxDisplayStatus.DECLINED_OTHER,
}

export const HiddenDeclineReasons: PrescriptionDeclineReasonType[] = []
